export interface approversEntities {
  roleId: string;
  rolename: string;
  userId: string;
  firstname: string;
  lastname: string;
  number: number;
  soApproverId?: string;
  sequenceId?: string;
}
export const approversEntities_INIT: approversEntities = {
  roleId: "",
  rolename: "",
  userId: "",
  firstname: "",
  lastname: "",
  number: 0,
  soApproverId: "",
  sequenceId: "",
};
export interface sequencesEntities {
  soApproverSequenceId: string;
  groupId: string;
  amount: string;
  roleId: string | undefined;
  rolename: string;
  minApprover: number;
  condition: string;
  approvers: approversEntities[];
  approval: any;
}
export const sequencesEntities_INIT: sequencesEntities = {
  soApproverSequenceId: "",
  groupId: "",
  amount: "",
  roleId: undefined,
  rolename: "",
  minApprover: 0,
  condition: "",
  approvers: [approversEntities_INIT],
  approval: [],
};
export interface soApproveEntities {
  soApproverGroupId: string;
  company: string;
  teamId: string;
  teamName: string;
  zones: string;
  createDate: string;
  createBy: string;
  updateDate: string;
  updateBy: string;
  isDelete: boolean;
  sequences: sequencesEntities[];
}
export const soApproveEntities_INIT: soApproveEntities = {
  soApproverGroupId: "",
  company: "",
  teamId: "",
  teamName: "",
  zones: "",
  createDate: "",
  createBy: "",
  updateDate: "",
  updateBy: "",
  isDelete: false,
  sequences: [sequencesEntities_INIT],
};
export interface AllSoApproveEntities {
  data: soApproveEntities[];
  updateBy: string;
  updateDate: string;
}
export const AllSoApprovedEntities_INIT: AllSoApproveEntities = {
  data: [soApproveEntities_INIT],
  updateBy: "",
  updateDate: "",
};
export interface CreateSoApproveEntities {
  company: string;
  teamId: string;
  teamName: string;
  zones: string[];
  sequences: sequencesEntities[];
  createBy: string;
}
export const DEFAULT_sequences = [
  {
    groupId: "",
    percent: 0,
    roleId: "",
    rolename: "",
    minApprover: 0,
    condition: "",
    approvers: [
      {
        sequenceId: "",
        roleId: "",
        rolename: "",
        userId: "",
        firstname: "",
        lastname: "",
        number: 0,
      },
    ],
  },
];
